import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { unAuthenticateRoutingModule } from './unAuthenticate-routing.module';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatExpansionModule} from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { SignatureComponent } from './signature/signature.component';
import { MatMenuModule } from '@angular/material/menu';
import { MatCardModule} from '@angular/material/card';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDialogModule } from '@angular/material/dialog';
import { SignupComponent } from './signup/signup.component';
import { SignaturePadModule } from 'ngx-signaturepad';
import { MatRadioModule} from '@angular/material/radio';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../middleware/shared/shared.module';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { MatButtonToggleModule} from '@angular/material/button-toggle';
import { ImageDrawingModule} from 'ngx-image-drawing';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { ThanksComponent } from './thanks/thanks.component';
import { DisableDirective } from '../../app/middleware/common/disable.directive';
import { CanvasComponent} from '../unAuthenticatedModules/Drawing/drawing.component';
import { LoaderService } from '../middleware/shared/loader/loader.service';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import {MatChipsModule} from '@angular/material/chips';
import { DndModule } from 'ngx-drag-drop';
import { AngularDraggableModule } from 'angular2-draggable';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { AngularResizedEventModule } from 'angular-resize-event';
import {MatCheckboxModule} from '@angular/material/checkbox';
import { AuditTrailsComponent } from './audit-trails/audit-trails.component';
import { RequestedDocumentsComponent } from './requestedDocuments/requested-documents.component';
import { AlreadyLoggedInComponent } from './already-logged-in/already-logged-in.component';
import { OrRoomDetailComponent } from './or-room-detail/or-room-detail.component';
import { MatTabsModule } from '@angular/material/tabs';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { ProjectFromFormLinkComponent } from './ProjectFromFormLink/projectFromFormLink.component';
import { TabularSignatureComponent } from './tabularsignature/tabularsignature.component';
import { ExternalTaskComponent } from './external-task/external-task.component';
import { MatBadgeModule } from '@angular/material/badge';
import { HTMLFormSignComponent } from './HTMLFormSign/HTMLFormSign.component';
import { HTMLThanksComponent } from './htmlthanks/htmlthanks.component';
import { ProjectDeletedComponent } from './project-deleted/project-deleted.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { FileManagerDocumentsComponent } from './fileManagerDocuments/fileManager-documents.component';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { FileManagerThanksComponent } from './fileManagerthanks/fileManagerthanks.component';
import { FileManagerViewerComponent } from './fileManagerFilesViewer/fileManager-viewer.component';
import { NgxDocViewerModule } from 'ngx-doc-viewer';
import { thanksExternalProjectComponent } from './thanksExternalProject/thanksExternalProject.component';
import { PortalUIComponent } from './portal-ui/portal-ui.component';
import { PortalDocumentViewerComponent } from './portal-ui/document-viewer/document-viewer.component';
import { AiDetailComponent } from '../middleware/shared/common/ai-detail/ai-detail.component';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { ExamplesComponent } from '../middleware/shared/common/examples/examples.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { TicketTaskComponent } from './ticket-task/ticket-task.component';
import { AddTicketTaskVm } from '../viewModels/core/core-vm';
import { ThanksAddTicketComponent } from './thanksAddTicket/thanksAddTicket.component';
import { DownloadService } from './signature/download.service';
import { DeclineurlComponent } from './declineurl/declineurl.component';
import { FormFolderUrlComponent } from './formFolderUrl/formFolderUrl.component';
import { ThanksAssignToSomeOneComponent } from './thanksAssignToSomeOne/thanksAssignToSomeOne.component';
import { thanksExternalProjectProgressiveComponent } from './thanksExternalProjectProgressive/thanksExternalProjectProgressive.component';
import { PortalSignatureComponent } from './portalsignature/portalsignature.component';

@NgModule({
  declarations: [HTMLFormSignComponent,ProjectFromFormLinkComponent,RequestedDocumentsComponent,TabularSignatureComponent, SignatureComponent, SignupComponent, ThanksComponent,thanksExternalProjectComponent,thanksExternalProjectProgressiveComponent,HTMLThanksComponent,DisableDirective,CanvasComponent, AuditTrailsComponent, AlreadyLoggedInComponent, OrRoomDetailComponent, ExternalTaskComponent,
    ProjectDeletedComponent,FileManagerDocumentsComponent,FileManagerThanksComponent,FileManagerViewerComponent, PortalUIComponent,
    PortalDocumentViewerComponent, AiDetailComponent,ExamplesComponent,TicketTaskComponent,ThanksAddTicketComponent,
    DeclineurlComponent,FormFolderUrlComponent,ThanksAssignToSomeOneComponent,PortalSignatureComponent],
  imports: [
    NgSelectModule,
    MatBadgeModule,
    MatChipsModule,
    CommonModule,
    unAuthenticateRoutingModule,
    MatIconModule,
    MatButtonModule,
    MatExpansionModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatMenuModule,
    MatCardModule,
    MatTooltipModule,
    MatDialogModule,
    SignaturePadModule,
    MatRadioModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    NgxMaterialTimepickerModule,
    MatButtonToggleModule,
    ImageDrawingModule,
    MatDatepickerModule,
    MatProgressSpinnerModule,
    DndModule,
    AngularDraggableModule,
    DragDropModule,
    AngularResizedEventModule,
    MatCheckboxModule,
    MatTabsModule,
    MatAutocompleteModule,
    MatProgressBarModule,
    NgxDocViewerModule,
    MatSlideToggleModule,
    PdfViewerModule
  ],
  providers: [    
    LoaderService,
    AddTicketTaskVm,
    DownloadService
  ],

})
export class UnAuthenticateModule { }
